
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import Parallax from '../Parallax';
import NoReceipts from './NoReceipts';
import { useParams } from 'react-router-dom';
import ReceiptsView from './ReceiptsView';
import { UserProfileContext } from '../context/UserProfileProvider';
import { MiscContext } from '../context/MiscProvider';
import { DomainContext } from '../context/DomainProvider';

import { CategoryContext } from '../context/CategoryContext';
import TitlesView from './TitlesView';
const Title = ({isTitleToBeProcessed, keyFromModal , setIsTitleToBeProcessed, setShowAlert}) => {
  const {documentsMap,  titles, setTitles} = useContext(MiscContext);
  const {selectDomains} = useContext(DomainContext);
  const {images} = useContext(UserProfileContext);
  const {selectCategories,setSelectCategories} = useContext(CategoryContext)
  const [entitiesCreated, setEntitiesCreated] = useState(false);

  const {key, type, isProcessed, isUnprocessed } = useParams();
  const [firm,setFirm] = useState( localStorage.getItem('FIRM'));

  
  useEffect(() => {
    let titleArray = [];
  try {
    const processed = isProcessed === "true";
    const unprocessed = (isUnprocessed === "true") || isTitleToBeProcessed;
    
    if (processed) {
        titleArray = documentsMap?.titlesProcessed[key] || [];
    } else if(unprocessed){      
        titleArray = documentsMap?.titlesUnProcessed[key || keyFromModal] || [];
        }
  
  } catch (error) {
    console.error('Error parsing documents:', error);
  }
    setTitles(titleArray || []);
  }, []);
  return (
    <>
    <Parallax />
    <section className='mt-3'>       
              {(titles?.length > 0 || keyFromModal)    ?
              <TitlesView setShowAlertForUnProcessed={setShowAlert}   titles={titles} setSelectCategories={setSelectCategories}  selectCategories={selectCategories} selectDomains={selectDomains} images={images} setTitles={setTitles} setEntitiesCreated={setEntitiesCreated} firm={firm} setIsTitleToBeProcessed={setIsTitleToBeProcessed}/>
                : <NoReceipts  setReceipts={setTitles} isReceipts={true} entitiesCreated={entitiesCreated} setEntitiesCreated={setEntitiesCreated}/>         
              }       
    </section>
</>
    
);
}

Title.propTypes = {
  isTitleToBeProcessed: PropTypes.bool,
  keyFromModal: PropTypes.string,
  setIsTitleToBeProcessed: PropTypes.func,
  setShowAlert: PropTypes.func,
};

export default Title;

